import React from 'react';
import * as enums from '@local/finsera-core/src/enums';
import { mui } from '@local/finsera-core/src/libs';

const allPeriods: { label: string; series_prefix: enums.PERIOD_ENUM }[] = [
  { label: '5D', series_prefix: enums.PERIOD_ENUM.FIVE_TRADING_DAYS },
  { label: '1M', series_prefix: enums.PERIOD_ENUM.ONE_MONTH },
  { label: '3M', series_prefix: enums.PERIOD_ENUM.THREE_MONTHS },
  { label: '6M', series_prefix: enums.PERIOD_ENUM.SIX_MONTHS },
  { label: 'YTD', series_prefix: enums.PERIOD_ENUM.YTD },
  { label: '1Y', series_prefix: enums.PERIOD_ENUM.ONE },
  { label: '3Y', series_prefix: enums.PERIOD_ENUM.THREE },
  { label: '5Y', series_prefix: enums.PERIOD_ENUM.FIVE },
  { label: 'Full', series_prefix: enums.PERIOD_ENUM.FULL },
];

type PeriodSelectorProps = {
  periods: enums.PERIOD_ENUM[];
  selectedPeriod: enums.PERIOD_ENUM;
  setSelectedPeriod: (_period: enums.PERIOD_ENUM) => void;
  margin?: number;
};

const PeriodSelector = ({ periods, selectedPeriod, setSelectedPeriod }: PeriodSelectorProps) => {
  return (
    <mui.core.Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', mt: 0, pr: 4 }}>
      <mui.core.ButtonGroup size="small">
        {allPeriods
          .filter((period) => periods.includes(period.series_prefix))
          .map((period) => (
            <mui.core.Button
              key={period.label}
              size="small"
              onClick={() => setSelectedPeriod(period.series_prefix)}
              variant={period.series_prefix === selectedPeriod ? 'contained' : 'outlined'}
              sx={{
                fontSize: '11px',
                borderRadius: '0!important',
                px: '1px !important',
                padding: '0 8px!important',
                minWidth: '2px!important',
                minHeight: '18px',
                '&:first-child': { borderTopLeftRadius: '8px !important', borderBottomLeftRadius: '8px !important' },
                '&:last-child': { borderTopRightRadius: '8px !important', borderBottomRightRadius: '8px !important' },
              }}
            >
              {period.label}
            </mui.core.Button>
          ))}
      </mui.core.ButtonGroup>
    </mui.core.Box>
  );
};

export default PeriodSelector;
